import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Countdown() {
    const { t } = useTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const raceDate = new Date("2026-05-17T00:00:00");
    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const distance = raceDate - now;

            if (distance < 0) {
                clearInterval(interval);
                setCountdown({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            setCountdown({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(interval);
    }, [raceDate]);
    return (
        <div className="w-full min-h-screen relative">
            <div className="w-full bg-heroMobile md:bg-hero h-screen bg-no-repeat bg-cover bg-center text-[#164481]">
                <div className="container mx-auto w-full relative h-full md:px-24">
                    <div className="flex max-lg:flex-wrap items-center justify-center lg:items-center lg:justify-center gap-y-0 relative h-1/2 md:max-lg:top-1/4 lg:h-full max-md:top-1/4 lg:gap-x-36">
                        <div className="2xl:basis-2/3 md:px-0 px-6 max-lg:order-2 max-lg:basis-full flex flex-wrap max-lg:justify-center">
                            <div className="lg:basis-full rounded-lg">
                                <div className="font-poppins font-bold">
                                    <div className="bg-white px-3 md:px-4 py-1 md:py-2 relative w-fit">
                                        <p className="text-lg md:text-2xl text-black" style={{ letterSpacing: '3px' }}>{t("hero.date")}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="w-fit pt-12">
                                <div className="grid grid-cols-2 md:grid-cols-4 text-center font-superWonder items-center xl:gap-y-10 gap-y-0 gap-x-0">
                                    <div className="text-right px-2 text-brandYellow 2xl:px-4 max-md:border-b border-white leading-none">
                                        <h2 className="text-9xl md:text-[10rem] font-superWonder font-black text-center md:text-right leading-[1] md:leading-[0.75]">
                                            {countdown.days}
                                        </h2>
                                        <p className="text-xl text-center md:text-right font-poppins text-white font-bold leading-none max-md:relative max-md:bottom-4">{t("hero.day")}</p>
                                    </div>
                                    <div className="text-right px-2 text-brandYellow 2xl:px-4 max-md:border-b border-l border-white leading-none">
                                        <h2 className="text-9xl md:text-[10rem] font-superWonder font-black text-center md:text-right leading-[1] md:leading-[0.75]">
                                            {countdown.hours}
                                        </h2>
                                        <p className="text-xl text-center md:text-right font-poppins text-white font-bold leading-none max-md:relative max-md:bottom-4">{t("hero.hour")}</p>
                                    </div>
                                    <div className="text-right px-2 text-brandYellow 2xl:px-4 md:border-l border-white leading-none">
                                        <h2 className="text-9xl md:text-[10rem] font-superWonder font-black text-center md:text-right leading-[1] md:leading-[0.75]">
                                            {countdown.minutes}
                                        </h2>
                                        <p className="text-xl text-center md:text-right font-poppins text-white font-bold leading-none max-md:relative max-md:bottom-4">{t("hero.minutes")}</p>
                                    </div>
                                    <div className="text-right px-2 text-brandYellow 2xl:px-4 border-l border-white leading-none">
                                        <h2 className="text-9xl md:text-[10rem] font-superWonder font-black text-center md:text-right leading-[1] md:leading-[0.75]">
                                            {countdown.seconds}
                                        </h2>
                                        <p className="text-xl text-center md:text-right font-poppins text-white font-bold leading-none max-md:relative max-md:bottom-4">{t("hero.seconds")}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="absolute bottom-12 left-0 md:block hidden">
                                <p className="text-white font-poppins font-light">#BANDUNGBERCERITA</p>
                            </div>
                            <div className="relative justify-center md:hidden block top-12">
                                <p className="text-white font-poppins font-light">#BANDUNGBERCERITA</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
